import React, { useState, useEffect } from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Grid } from '@mui/material';
import ConfirmModal from '../../modals/confirmx'; // Modal de confirmação
import FeedbackModal from '../../modals/FeedbackModal'; // Modal de feedback
import { createFamilia, getFamilies, updateFamilia } from '../../../services/api';

const productTypesOptions = [
  { label: 'Finished Product', value: 'finished_product' },
  { label: 'Paper Reel', value: 'paper_reel' },
  { label: 'Rope', value: 'rope' },
  { label: 'Reinforcement', value: 'reinforcement' },
  { label: 'Packing Box', value: 'packing_box' }, // Nova opção adicionada
  { label: 'None', value: 'none' }
];


const FamilyManager = () => {
  // Estados para criação de família
  const [familiaData, setFamiliaData] = useState({
    nome: '',
    descricao: ''
  });
  const [confirmCreateVisible, setConfirmCreateVisible] = useState(false);
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submissionComplete, setSubmissionComplete] = useState(false);
  const [submissionError, setSubmissionError] = useState(null);

  // Estados para listagem de famílias e atribuição de product_type
  const [families, setFamilies] = useState([]);
  const [loadingFamilies, setLoadingFamilies] = useState(false);

  // Função para buscar as famílias já criadas
  const fetchFamilies = async () => {
    setLoadingFamilies(true);
    try {
      const response = await getFamilies();
      setFamilies(response.data);
    } catch (error) {
      console.error("Erro ao buscar famílias:", error);
    } finally {
      setLoadingFamilies(false);
    }
  };

  // Buscar famílias ao montar o componente
  useEffect(() => {
    fetchFamilies();
  }, []);

  // Manipulador de alteração dos inputs de criação de família
  const handleChange = (e) => {
    const newData = { ...familiaData, [e.target.name]: e.target.value };
    setFamiliaData(newData);
    console.log('Payload atualizado:', newData);
  };

  // Função para criar a família
  const handleCreateFamilia = async () => {
    console.log('Criando família com os dados:', familiaData);
    setIsSubmitting(true);
    setFeedbackOpen(true);
    setSubmissionError(null);
    try {
      const response = await createFamilia(familiaData);
      console.log('Família criada:', response.data);
      setSubmissionComplete(true);
      // Atualiza a lista de famílias após a criação
      fetchFamilies();
    } catch (error) {
      console.error('Erro ao criar família:', error);
      setSubmissionError(error.message || 'Erro desconhecido');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleConfirmCreate = () => {
    setConfirmCreateVisible(true);
  };

  const onConfirmCreate = () => {
    setConfirmCreateVisible(false);
    handleCreateFamilia();
  };

  const onCancelCreate = () => {
    setConfirmCreateVisible(false);
  };

  // Atualiza o product_type da família selecionada
  const handleProductTypeChange = async (familyId, newProductType) => {
    try {
      await updateFamilia(familyId, { product_type: newProductType });
      // Atualiza o estado local para refletir a alteração
      setFamilies(families.map(f => f.id === familyId ? { ...f, product_type: newProductType } : f));
    } catch (error) {
      console.error("Erro ao atualizar product type:", error);
    }
  };

  const handleSaveFamilies = async () => {
    try {
      // Atualiza cada família individualmente
      for (const family of families) {
        await updateFamilia(family.id, { product_type: family.product_type });
      }
      alert("Famílias e seus Product Types foram salvos com sucesso!");
    } catch (error) {
      console.error("Erro ao salvar famílias:", error);
      alert("Erro ao salvar famílias.");
    }
  };

  const headerCreate = (
    <div style={{ position: 'relative' }}>
      <h2>Criar Família</h2>
    </div>
  );

  return (
    <div>
      {/* Seção para criação de família */}
      <Card header={headerCreate} style={{ marginBottom: '2rem' }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <div className="p-field">
              <label htmlFor="nome">Nome</label>
              <InputText 
                id="nome" 
                name="nome" 
                value={familiaData.nome} 
                onChange={handleChange} 
                style={{ width: '100%' }} 
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={6}>
            <div className="p-field">
              <label htmlFor="descricao">Descrição</label>
              <InputText 
                id="descricao" 
                name="descricao" 
                value={familiaData.descricao} 
                onChange={handleChange} 
                style={{ width: '100%' }} 
              />
            </div>
          </Grid>
          <Grid item xs={12}>
            <Button 
              label="Confirmar Criação" 
              icon="pi pi-check" 
              className="p-button-success" 
              onClick={handleConfirmCreate}
            />
          </Grid>
        </Grid>

        {/* Modal de confirmação para criação */}
        <ConfirmModal 
          visible={confirmCreateVisible}
          message="Deseja confirmar a criação desta família?"
          onConfirm={onConfirmCreate}
          onCancel={onCancelCreate}
        />
      </Card>

      {/* Modal de feedback para submissão */}
      <FeedbackModal 
        open={feedbackOpen}
        isSubmitting={isSubmitting}
        submissionComplete={submissionComplete}
        error={submissionError}
        onClose={() => setFeedbackOpen(false)}
      />

      {/* Seção para listar as famílias e atribuir product_type */}
      <Card header={<h2>Famílias e seus Product Types</h2>} style={{ marginBottom: '2rem' }}>
        {loadingFamilies ? (
          <p>Carregando famílias...</p>
        ) : (
          <Grid container spacing={2}>
            {families.map(family => (
              <Grid item xs={12} sm={6} md={4} key={family.id}>
                <Card title={family.name}>
                  <p>{family.description}</p>
                  <Dropdown 
                    value={family.product_type} 
                    options={productTypesOptions} 
                    onChange={(e) => handleProductTypeChange(family.id, e.value)}
                    placeholder="Selecione um Product Type"
                    />
                </Card>
              </Grid>
            ))}
          </Grid>
        )}
      </Card>

      {/* Botão para guardar as alterações das famílias */}
      <Button 
        label="Guardar Famílias" 
        icon="pi pi-save" 
        className="p-button-warning" 
        onClick={handleSaveFamilies}
      />
    </div>
  );
};

export default FamilyManager;
